import React from 'react'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import { ZinIcon } from '@tnl/zin-react'
import './AccountMenuItem.scss'

export interface AccountMenuItemProps {
  label: string
  icon?: string | React.ReactNode
  onClick?: (e: any) => void
  link?: string
  className?: string
  disabled?: boolean
}

export const AccountMenuItem: React.FC<AccountMenuItemProps> = ({ label, icon, onClick, link, className = '', disabled = false }) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return

    if (onClick) {
      onClick(e)
    } else if (link) {
      navigate(link)
    }
  }

  const renderIcon = () => {
    if (!icon) return null

    if (typeof icon === 'string') {
      return <ZinIcon name={icon} />
    }

    return icon
  }

  return (
    <button
      type="button"
      className={clsx('account-menu-item', className)}
      onClick={handleClick}
      disabled={disabled}
      data-testid={`account-menu-item-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      {renderIcon()}
      <span className="account-menu-item__label body-1 font-semibold">{label}</span>
      <ZinIcon
        name="chevron-right"
        set="fas"
        className="account-menu-item__chevron"
      />
    </button>
  )
}
